import { initStripe, injectStripeLib } from '@anm/helpers/stripe';
import { useEffect } from 'react';

import vtConfig from '../../../config';

const {
  stripe: { key }
} = vtConfig();

const useInitStripe = () => {
  injectStripeLib();

  useEffect(() => {
    initStripe({ key });
  }, []);
};

export default useInitStripe;
